import { createCompoundComponent } from '../../utilities'
import { TransitionProvider as BaseTransitionController } from './TransitionProvider'
import { Trigger } from './Trigger'

export const TransitionController = createCompoundComponent(
  BaseTransitionController,
  {
    Trigger,
  },
)

export * from './FadeInOut'
